<template>
<div class="template">
    <div class="flex jc-sb ai-c">
        <div class="flex-33">
            <button
                title="Filters"
                type="button"
                :disabled="is_loading"
                :class="{ 'primary': show_filters }"
                @click="show_filters = !show_filters">
                <i class="material-icons">filter_list</i>
                <span v-if="show_filters">Hide Filters</span>
                <span v-else>Show Filters</span>
            </button>
        </div>

        <div class="flex-33 ta-c">
            <vue-table-pagination
                ref="archived_facilities_table_pagination"
                @vuetable-pagination:change-page="onChangePage">
            </vue-table-pagination>
        </div>

        <div class="flex-33 ta-r">
            <button
                title="Refresh"
                type="button"
                :disabled="is_loading"
                @click="onLoadData">
                <i class="material-icons">refresh</i>
            </button>
        </div>
    </div>

    <div v-show="show_filters" class="flex ai-fe mt-3">
        <div style="margin-left: 9px; width: 159px;">
            <label for="filter-facility-number">Facility Number</label>
            <input id="filter-facility-number" type="text" :disabled="is_loading" v-model="filters.facility_number" />
        </div>

        <!-- Margin-left accounts for 16 + 1px border -->
        <!-- Width is column width - 16px -->
        <div style="margin-left: 17px; width: 209px;">
            <label for="filter-letter-effective-date">Letter Effective Date</label>
            <datepicker
                :disabled="is_loading"
                :typeable="true"
                v-model="filters.letter_effective_date" :format="'yyyy-MM-dd'" />
        </div>
    </div>

    <div :class="['loading-wrapper', 'mt-4', { loading: is_loading }]">
        <vue-table ref="archived_facilities_table"
            api-url="/api/facility-archives"
            data-path="data.data"
            pagination-path="data.pagination"
            :http-options="http_options"
            :per-page="100"
            :append-params="api_params"
            :fields="columns"
            table-height="475px"
            @vuetable:loading="is_loading = true"
            @vuetable:loaded="is_loading = false"
            @vuetable:pagination-data="onPaginationData"
            no-data-template="<span>No exports to show.</span>">
            <template slot="percent_complete" slot-scope="props">
                <div class="flex ai-c jc-c pos-r">
                    <!-- <radial-progress-bar
                        :diameter="55"
                        :stroke-width="5"
                        :completed-steps="Math.floor(props.rowData.percent_complete)"
                        :total-steps="100"
                        inner-stroke-color="#e8e8e8"
                        start-color="#83dbb3"
                        stop-color="#83dbb3" /> -->

                    <span class="percent-complete-text pos-a">
                        {{ Math.floor(props.rowData.percent_complete) }}%
                    </span>
                </div>
            </template>

            <template slot="download" slot-scope="props">
                <a
                    :href="`${api_base_path}/api/facility-archives/download-export?filename=${props.rowData.facility_number}_${props.rowData.prime_site_id}_${props.rowData.letter_effective_date}.xlsx`"
                    target="_blank">
                    Download
                </a>
            </template>
        </vue-table>
    </div>
</div>
</template>

<script>
import http from "@/http"
import store from "@/store"
// import RadialProgressBar from "vue-radial-progress"
import { archivedFacilitiesColumns } from "@/utilities/columns"
import { debounce } from "lodash"

export default {
    // components: {
    //     RadialProgressBar
    // },

    data () {
        return {
            columns: archivedFacilitiesColumns,
            filters: {
                faciltiy_number: "",
                letter_effective_date: ""
            },
            http_options: {
                baseURL: http.defaults.baseURL,
                headers: { "X-Authorization": store.state.token.token }
            },
            is_loading: false,
            show_filters: false
        }
    },

    computed: {
        api_base_path () {
            return http.defaults.baseURL
        },

        api_params () {
            const params = {}

            for (const key in this.filters) {
                const value = this.filters[key]

                if (typeof value === "string") {
                    if (value.trim().length !== 0) {
                        params[key] = value.trim()
                    }
                } else if (value instanceof Date) {
                    params[key] = `${value.getFullYear()}-${value.getMonth() + 1}-${value.getDate()}`
                }
            }

            return params
        }
    },

    created () {
        this.$watch("filters", debounce(this.onLoadData, 350), { deep: true })
    },

    methods: {
        /**
         * Change the pagination page when requested.
         *
         * @param object page Page
         */
        onChangePage (page) {
            this.$refs.archived_facilities_table.changePage(page)
        },

        /**
         * Update the pagination component when data is received.
         *
         * @param object paginationData Pagination data
         *
         * @return null
         */
        onPaginationData (paginationData) {
            this.$refs.archived_facilities_table_pagination.setPaginationData(paginationData)
        },

        /**
         * Tell the table to pull new data.
         */
        onLoadData () {
            this.$refs.archived_facilities_table.reload()
        }
    }
}
</script>

<style scoped>
.filter-input {
    width: 150px;
}

.template /deep/ .vdp-datepicker__calendar {
    top: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/list-facilities-page/FacilityArchivesTab.vue